/**
 * About page - Exam Portal
 */

import React from 'react';

const About: React.FC = () => {
  return (
    <div className="page page-default" data-testid="about-page">
      <header className="page-header">
        <h1>About Us</h1>
        <p>Empowering institutions with a modern, secure online examination platform.</p>
      </header>

      <section className="page-section grid-2">
        <div>
          <h2>Our Mission</h2>
          <p>
            We aim to make assessments simple, fair, and accessible. From creating question
            banks to grading submissions, we streamline the entire examination lifecycle.
          </p>
        </div>
        <div>
          <h2>What We Offer</h2>
          <ul className="list">
            <li>Robust exam creation and scheduling</li>
            <li>Secure test-taking experience</li>
            <li>Automated and manual evaluation tools</li>
            <li>Real-time insights and analytics</li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default About;
